"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BulkRenewalStatus;
(function (BulkRenewalStatus) {
    BulkRenewalStatus["IN_PROGRESS"] = "in progress";
    BulkRenewalStatus["COMPLETED"] = "completed";
    BulkRenewalStatus["FAILED"] = "failed";
    BulkRenewalStatus["COMPLETE_WITH_ERROR"] = "renewal completed with error";
    BulkRenewalStatus["RENEWAL_COMPLETED"] = "renewal completed";
})(BulkRenewalStatus = exports.BulkRenewalStatus || (exports.BulkRenewalStatus = {}));
var BulkRenewalAction;
(function (BulkRenewalAction) {
    BulkRenewalAction["DOWNLOAD"] = "download";
    BulkRenewalAction["RENEWAL"] = "renewal";
})(BulkRenewalAction = exports.BulkRenewalAction || (exports.BulkRenewalAction = {}));
var BulkRenewalMembershipType;
(function (BulkRenewalMembershipType) {
    BulkRenewalMembershipType["HONORARY"] = "honorary";
    BulkRenewalMembershipType["STUDENT"] = "student";
    BulkRenewalMembershipType["HONORARY_AND_STUDENT"] = "honorary and student";
})(BulkRenewalMembershipType = exports.BulkRenewalMembershipType || (exports.BulkRenewalMembershipType = {}));
var BulkRenewalSKUs;
(function (BulkRenewalSKUs) {
    BulkRenewalSKUs["HONORARY22"] = "MEMREGHON22";
    BulkRenewalSKUs["HONORARYSO22"] = "MEMRETSO222";
    BulkRenewalSKUs["STUDENT"] = "MEMSTUAFF0122";
})(BulkRenewalSKUs = exports.BulkRenewalSKUs || (exports.BulkRenewalSKUs = {}));
var CVAndCustomFields;
(function (CVAndCustomFields) {
    CVAndCustomFields["RENEWAL_STATUS"] = "Renewal Status";
    CVAndCustomFields["SUCCESS"] = "SUCCESS";
    CVAndCustomFields["FAILED"] = "FAILED";
    CVAndCustomFields["OKTA_ID"] = "OKTA Id";
    CVAndCustomFields["AICPA_ID"] = "AICPA ID";
    CVAndCustomFields["ACCOUNT_NUMBER"] = "AccountNumber";
    CVAndCustomFields["ACCOUNT_NUMBER_SPACE"] = "Account Number";
    CVAndCustomFields["RATE_PLAN_CHARGE"] = "Rate Plan Charge Bundle Name";
    CVAndCustomFields["MEMBERSHIP_TYPE_C"] = "membershiptype__c";
    CVAndCustomFields["END_DATE"] = "End Date";
    CVAndCustomFields["RENEWAL_STATUS_FAILED"] = "Failed";
    CVAndCustomFields["RENEWAL_STATUS_SUCCESS"] = "Success";
    CVAndCustomFields["MEMBERSHIP_TYPE"] = "Membership Type";
    CVAndCustomFields["ORDER_NUMBER"] = "Order Number";
    CVAndCustomFields["PRODUCT_SKU"] = "Product SKU";
    CVAndCustomFields["SUBSCRIPTION_NUMBER"] = "Subscription Number";
    CVAndCustomFields["PRODUCT_NAME"] = "Product Name";
    CVAndCustomFields["SALES_FORCE_ID_UFFEF"] = "\uFEFFSalesforce ID";
    CVAndCustomFields["BUNDLE_NAME"] = "Bundle Name";
    CVAndCustomFields["NONE_VALUE"] = "none";
    CVAndCustomFields["EXPIRY_DATE"] = "Expiry Date";
    CVAndCustomFields["MEMBERSHIP_TERM"] = "Membership Term Id";
    CVAndCustomFields["ACCOUNT_NAME"] = "Account Name";
    CVAndCustomFields["MEMBERSHIP_TIER"] = "Membership Tier";
    CVAndCustomFields["HONORARY"] = "Honorary";
})(CVAndCustomFields = exports.CVAndCustomFields || (exports.CVAndCustomFields = {}));
var BulkRenewalStatusDescription;
(function (BulkRenewalStatusDescription) {
    BulkRenewalStatusDescription["INDICATOR_CODE_1"] = "Success and Completed";
    BulkRenewalStatusDescription["INDICATOR_CODE_2"] = "Encountered error processing CT (Failed Getting Okta Id)";
    BulkRenewalStatusDescription["INDICATOR_CODE_3"] = "Encountered error processing CT (Already Renewed)";
    BulkRenewalStatusDescription["INDICATOR_CODE_4"] = "Encountered error processing CT (Failed Getting CT User)";
    BulkRenewalStatusDescription["INDICATOR_CODE_5"] = "Encountered error processing CT (Failed During Deprovision)";
    BulkRenewalStatusDescription["INDICATOR_CODE_6"] = "Encountered error processing CT (Failed During Order Import On CT)";
    BulkRenewalStatusDescription["INDICATOR_CODE_7"] = "Encountered error processing CT (Failed During Provisioning)";
    BulkRenewalStatusDescription["INDICATOR_CODE_8"] = "Encountered error processing CT";
    BulkRenewalStatusDescription["INDICATOR_CODE_9"] = "Encountered error processing Zuora";
    BulkRenewalStatusDescription["INDICATOR_CODE_10"] = "Encountered error processing CT";
    BulkRenewalStatusDescription["INDICATOR_CODE_11"] = "Encountered error processing Salesforce (Failed During Membership Update)";
    BulkRenewalStatusDescription["INDICATOR_CODE_12"] = "Encountered error processing Salesforce (Failed During Create SalesForce Order)";
    BulkRenewalStatusDescription["INDICATOR_CODE_13"] = "Encountered error processing Salesforce";
})(BulkRenewalStatusDescription = exports.BulkRenewalStatusDescription || (exports.BulkRenewalStatusDescription = {}));
var BulkRenewalDynamoEventName;
(function (BulkRenewalDynamoEventName) {
    BulkRenewalDynamoEventName["MODIFY"] = "MODIFY";
    BulkRenewalDynamoEventName["INSERT"] = "INSERT";
    BulkRenewalDynamoEventName["DELETE"] = "DELETE";
})(BulkRenewalDynamoEventName = exports.BulkRenewalDynamoEventName || (exports.BulkRenewalDynamoEventName = {}));
//# sourceMappingURL=index.js.map